import { usersMassiveService } from "@/services/users_massive_service.js";
import Swal from "sweetalert2";
import {
  ACTION_SET_PROCESS_STATE,
  ACTION_SET_SELECTED_FILE,
  ACTION_SET_UPLOAD_PROGRESS,
  ACTION_SET_VALIDATION_RESULT,
  ACTION_SET_PROCESS_RESULT,
  ACTION_SET_UPLOAD_DRAWER_OPEN,
  ACTION_SET_DELETE_DRAWER_OPEN,
  ACTION_SET_CURRENT_STEP,
  ACTION_SET_ERRORS,
  ACTION_MASSIVE_UPLOAD,
  ACTION_MASSIVE_DELETE,
  ACTION_DOWNLOAD_TEMPLATE,
  ACTION_DOWNLOAD_DELETE_TEMPLATE,
  ACTION_RESET_PROCESS
} from "../actions.js";
import {
  MUTATION_SET_PROCESS_STATE,
  MUTATION_SET_SELECTED_FILE,
  MUTATION_SET_UPLOAD_PROGRESS,
  MUTATION_SET_VALIDATION_RESULT,
  MUTATION_SET_PROCESS_RESULT,
  MUTATION_SET_UPLOAD_DRAWER_OPEN,
  MUTATION_SET_DELETE_DRAWER_OPEN,
  MUTATION_SET_CURRENT_STEP,
  MUTATION_SET_ERRORS,
  MUTATION_RESET_PROCESS
} from "../mutations.js";

export default {
  [ACTION_SET_PROCESS_STATE]({ commit }, state) {
    commit(MUTATION_SET_PROCESS_STATE, state);
  },
  [ACTION_SET_SELECTED_FILE]({ commit }, file) {
    commit(MUTATION_SET_SELECTED_FILE, file);
  },
  [ACTION_SET_UPLOAD_PROGRESS]({ commit }, progress) {
    commit(MUTATION_SET_UPLOAD_PROGRESS, progress);
  },
  [ACTION_SET_VALIDATION_RESULT]({ commit }, result) {
    commit(MUTATION_SET_VALIDATION_RESULT, result);
  },
  [ACTION_SET_PROCESS_RESULT]({ commit }, result) {
    commit(MUTATION_SET_PROCESS_RESULT, result);
  },
  [ACTION_SET_UPLOAD_DRAWER_OPEN]({ commit }, isOpen) {
    commit(MUTATION_SET_UPLOAD_DRAWER_OPEN, isOpen);
  },
  [ACTION_SET_DELETE_DRAWER_OPEN]({ commit }, isOpen) {
    commit(MUTATION_SET_DELETE_DRAWER_OPEN, isOpen);
  },
  [ACTION_SET_CURRENT_STEP]({ commit }, step) {
    commit(MUTATION_SET_CURRENT_STEP, step);
  },
  [ACTION_SET_ERRORS]({ commit }, errors) {
    commit(MUTATION_SET_ERRORS, errors);
  },
  [ACTION_MASSIVE_UPLOAD]({ commit }, { idGroup, idEmpresa, file }) {
    commit(MUTATION_SET_PROCESS_STATE, 'LOADING');
    commit(MUTATION_SET_ERRORS, []);
    return usersMassiveService.massiveUpload(idGroup, idEmpresa, file)
      .then(response => {
        const result = response.data.payload;
        commit(MUTATION_SET_PROCESS_RESULT, result);
        if (result.errors && result.errors.length > 0) {
          commit(MUTATION_SET_ERRORS, result.errors);
        }
        commit(MUTATION_SET_PROCESS_STATE, 'SUCCESS');
        return result;
      })
      .catch(error => {
        commit(MUTATION_SET_PROCESS_STATE, 'ERROR');
        throw error;
      });
  },
  [ACTION_MASSIVE_DELETE]({ commit }, { idGroup, idEmpresa, file }) {
    commit(MUTATION_SET_PROCESS_STATE, 'LOADING');
    commit(MUTATION_SET_ERRORS, []);
    return usersMassiveService.massiveDelete(idGroup, idEmpresa, file)
      .then(response => {
        const result = response.data.payload;
        commit(MUTATION_SET_PROCESS_RESULT, result);
        if (result.errors && result.errors.length > 0) {
          commit(MUTATION_SET_ERRORS, result.errors);
        }
        commit(MUTATION_SET_PROCESS_STATE, 'SUCCESS');
        return result;
      })
      .catch(error => {
        commit(MUTATION_SET_PROCESS_STATE, 'ERROR');
        throw error;
      });
  },
  [ACTION_DOWNLOAD_TEMPLATE](context, { idEmpresa }) {
    if (!idEmpresa) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo obtener el idEmpresa para descargar la plantilla',
        confirmButtonColor: '#6E17A5'
      });
      return Promise.reject(new Error('idEmpresa no proporcionado'));
    }
    return usersMassiveService.downloadUploadTemplate(idEmpresa)
      .then(response => {
        if (!response || !response.data) {
          throw new Error('Respuesta inválida del servidor');
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'plantilla_carga_usuarios.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al descargar la plantilla de carga. Verifica que el servicio loader-service esté disponible y configurado correctamente.',
          confirmButtonColor: '#6E17A5'
        });
        throw error;
      });
  },
  [ACTION_DOWNLOAD_DELETE_TEMPLATE](context, { idEmpresa }) {
    if (!idEmpresa) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo obtener el idEmpresa para descargar la plantilla',
        confirmButtonColor: '#6E17A5'
      });
      return Promise.reject(new Error('idEmpresa no proporcionado'));
    }
    return usersMassiveService.downloadDeleteTemplate(idEmpresa)
      .then(response => {
        if (!response || !response.data) {
          throw new Error('Respuesta inválida del servidor');
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'plantilla_eliminacion_usuarios.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al descargar la plantilla de eliminación. Verifica que el servicio loader-service esté disponible y configurado correctamente.',
          confirmButtonColor: '#6E17A5'
        });
        throw error;
      });
  },
  [ACTION_RESET_PROCESS]({ commit }) {
    commit(MUTATION_RESET_PROCESS);
  }
};
